import parseRange from '@/api/shared/utility/parseRange';

function parseStatType(statType) {
  if (!statType.length) return null;
  return statType[statType.length - 1];
}

/**
 * It normalizes the chart params
 * @param {Object} statFilters - The object which represents filters of the stats
 * @param {string} statFilters.campaignId - The campaign ID
 * @param {number[]} statFitlers.bids - An array of bids IDs
 * @param {string} statFitlers.range - Range of the stats
 * @param {string} statFilters.statType - The type of the data
 * @returns {Object} params which is the normalized params
 * @returns {string} params.itemId which is the campaignId
 * @returns {string} params.bids which is a string of bids
 * @returns {string} params.stat_type which is the stat type
 * @returns {string} params.range which is the range
 */
export default function normalizeChartParams({
  campaignId,
  bids,
  range,
  statType,
}) {
  const params = {
    itemId: campaignId,
    bids: bids.join(','),
    stat_type: parseStatType(statType),
    ...parseRange(range),
  };
  return params;
}
